import GdriveLogo from "@/assets/icons/gdriveLogo.svg";
import GmailLogo from "@/assets/icons/gmailLogo.svg";
import OnedriveLogo from "@/assets/icons/onedriveLogo.svg";
import DropboxLogo from "@/assets/icons/dropboxLogo.svg";
import CalendarLogo from "@/assets/icons/calendarLogo.svg";
import JiraLogo from "@/assets/icons/jiraLogo.svg";
export const steps = [
    { personas: "Role selection" },
    { "data sources": "Data sources" },
    { done: "Space setup" },
];
// export const steps = ["personas", "data sources", "done"];
export const personas = [
    "Product Owner",
    "Full Stack Developer",
    "CEO",
    "CMO",
    "CTO",
    "Project Manager",
    "UI Engineer",
    "Graphic Designer",
    "Content Writer",
];
export const dataSources = [
    {
        label: "Google Drive",
        subtitle: "(Powered by Agentspace)",
        icon: GdriveLogo,
        scope: "https://www.googleapis.com/auth/drive https://www.googleapis.com/auth/drive.readonly https://www.googleapis.com/auth/cloud-platform", //"https://www.googleapis.com/auth/drive.readonly,https://www.googleapis.com/auth/drive.file",
    },
    {
        label: "Gmail",
        subtitle: "(Powered by Agentspace)",
        icon: GmailLogo,
        scope: "https://www.googleapis.com/auth/gmail.readonly https://www.googleapis.com/auth/gmail.send https://www.googleapis.com/auth/cloud-platform",
    },
    {
        label: "Calendar",
        subtitle: "",
        icon: CalendarLogo,
        scope: "https://www.googleapis.com/auth/calendar.readonly",
    },
    {
        label: "Jira",
        subtitle: "(Powered by Agentspace)",
        icon: JiraLogo,
        scope: "https://www.googleapis.com/auth/cloud-platform",
    },
    // { label: "Onedrive", icon: OnedriveLogo },
    // { label: "Dropbox", icon: DropboxLogo },
];
export const DATA_SOURCES = [
    {
        category: "Gmail",
        subtitle: "(Powered by Agentspace)",
        icon: GmailLogo,
        scopes: [
            {
                label: "Readonly",
                scope: "https://www.googleapis.com/auth/gmail.readonly",
            },
            {
                label: "Send",
                scope: "https://www.googleapis.com/auth/gmail.send",
            },
        ],
    },
    {
        category: "Calendar",
        icon: CalendarLogo,
        scopes: [
            {
                label: "Readonly",
                scope: "https://www.googleapis.com/auth/calendar.readonly",
            },
        ],
    },
    {
        category: "Jira",
        subtitle: "(Powered by Agentspace)",
        icon: JiraLogo,
        scopes: [
            {
                label: "Full Access",
                scope: "https://www.googleapis.com/auth/cloud-platform",
            },
        ],
    },
    {
        category: "Google Drive",
        subtitle: "(Powered by Agentspace)",
        icon: GdriveLogo,
        scopes: [
            {
                label: "Full Access",
                scope: "https://www.googleapis.com/auth/drive",
            },
        ],
    },
];
export const userSpaceOptions = [
    { label: "Create Content", icon: GdriveLogo },
    { label: "Create Transcriptions", icon: GmailLogo },
    { label: "Generate Images", icon: OnedriveLogo },
    { label: "Gather Requirements", icon: DropboxLogo },
];
